import { Box, CssBaseline, Icon, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import React, { useContext, useEffect } from 'react';
import { AuthContext } from '@/js/shared/context/AuthContext';
import MessageContext from '@/js/shared/context/MessageContext';
import { EventContext } from '@/js/site/context/EventContext';
import EventDashboard from '@/js/site/components/dashboards/EventDashboard';
import { RouteComponentProps } from 'react-router-dom';
import { LiveContainer } from '@/js/live/LiveContainer';

type IProps = RouteComponentProps & {
  match: {
    params: {
      eventId: string;
      roomId: string;
    };
  };
};

export const Session = withStyles(() => ({}))((props: IProps) => {
  const { authState } = useContext(AuthContext); // Hämta Context
  const { eventState, actions } = useContext(EventContext); // Hämta Context

  useEffect(() => {
    if (props.match.params.roomId) {
      actions.loadEventDetailByRoomId(props.match.params.roomId);
    } else if (props.match.params.eventId) {
      actions.loadEventDetail(props.match.params.eventId, true);
    }
  }, [authState.userLoggedIn]);

  return (
    <LiveContainer>
      {eventState.eventLoaded ? (
        eventState.event ? (
          <MessageContext>
            <EventDashboard {...props} eventId={props.match.params.eventId} />
          </MessageContext>
        ) : !eventState.hasTicketAccess ? (
          <Box textAlign="center" pt={4}>
            <Typography variant="h5">
              <Icon>lock</Icon>
              <br />
              {(window as any).LANG.TICKET_ACCESS_MSG}
            </Typography>
          </Box>
        ) : (
          <Box textAlign="center" pt={3}>
            <div>{eventState.event}</div>

            {eventState.eventError || '404 No such event'}
          </Box>
        )
      ) : (
        // @ts-ignore
        <Box align="center">
          <CssBaseline />
          <CircularProgress disableShrink />
        </Box>
      )}
    </LiveContainer>
  );
});
